
import { Injectable } from '@angular/core';
import { SiriusServiceBase } from '@ibtech/sirius-angular-service';

@Injectable()
export class TimeoutPopupService extends SiriusServiceBase {
    static popup: any;

    add(popupTemp: any) {
        TimeoutPopupService.popup = popupTemp;
    }

    showPopup() {
        TimeoutPopupService.popup.open();
    }

    closePopup() {
        TimeoutPopupService.popup.close();
    }
}
